import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestStatistic } from "./statistic.request";
import { StatisticRequestParams, StatisticResponse } from "./statistic.types";

const useStatistic = (
  params: StatisticRequestParams,
  options?: QueryOptions<StatisticResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["statistic", params],
    queryFn: async () => await requestStatistic(params),
    ...options
  });

  return { statistic: data, ...rest };
};

export default useStatistic;
